import { useField } from 'formik'
import omit from 'lodash-es/omit'

import { EMPTY_LIST } from '../../../constants/common'

import {
  getEmailRecipientsFieldUnlockedValue,
  getEmailRecipientsFieldValueWithLocked,
} from './EmailRecipientsField.utils'
import { EmailRecipientsSelect } from './EmailRecipientsSelect'

function EmailRecipientsField({
  lockedValues = EMPTY_LIST,
  name,
  onChange,
  ...props
}) {
  const [field] = useField(name)

  // Locked chips lead the field and never enter its value
  const value = getEmailRecipientsFieldValueWithLocked({
    lockedValues,
    value: field.value || EMPTY_LIST,
  })

  const selectProps = omit(props, ['isLoading', 'loadInitialValue'])

  function handleChange(nextValue) {
    onChange?.(
      getEmailRecipientsFieldUnlockedValue({ lockedValues, value: nextValue })
    )
  }

  return (
    <EmailRecipientsSelect
      {...selectProps}
      name={name}
      value={value}
      onChange={handleChange}
    />
  )
}

export default EmailRecipientsField
